import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

import { SectionContainer } from './common/SectionContainer';
import Paragraph from './common/Paragraph';
import Button from './common/Button';
import { FaLinkedinIn, FaGithub, FaBehance, FaMediumM } from 'react-icons/fa';

import { COLORS, SIZE } from './common/constants';

const Email = () => {
	const [isCopied, setIsCopied] = useState(false);

	const handleCopy = () => {
		navigator.clipboard
			.writeText('wondasom93@gmail.com')
			.then(function () {
				setIsCopied(true);
			})
			.then(reset);
	};

	const reset = () => {
		setTimeout(() => {
			setIsCopied(false);
		}, 3000);
	};

	return (
		<StyledContainer id='contact'>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center'
				}}
			>
				<Title>Contact Me</Title>
				<Button text='wondasom93@gmail.com' onClick={handleCopy}></Button>
				{isCopied ? <CopyMessage>Email Copied!</CopyMessage> : null}
			</div>
			<Footer>
				<LinkList>
					<a
						href='https://www.linkedin.com/in/dasom-won-8a1594190/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaLinkedinIn style={{ fontSize: '1.6rem' }} />
						</Link>
					</a>
					<a
						href='https://github.com/wondasom'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaGithub style={{ fontSize: '1.6rem' }} />
						</Link>
					</a>
					<a
						href='https://www.behance.net/wondasom'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaBehance
								style={{
									fontSize: '2.05rem',
									position: 'relative',
									top: '-4px'
								}}
							/>
						</Link>
					</a>
					<a
						href='https://medium.com/swlh/7-things-ive-learned-during-the-time-at-a-coding-bootcamp-d402f4504e4a'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaMediumM
								style={{
									fontSize: '1.7rem',
									position: 'relative',
									top: '-2px'
								}}
							/>
						</Link>
					</a>
				</LinkList>
			</Footer>
		</StyledContainer>
	);
};

export default Email;
const StyledContainer = styled.div`
	width: 85%;
	height: 50vh;
	margin: 0 auto;
	padding: 3em 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	@media (max-width: ${SIZE.small}) {
		width: 90%;
		padding: 0;
		height: 30vh;
	}
`;

const Title = styled.h1`
	font-size: calc(30px + (36 - 30) * ((100vw - 300px) / (1600 - 300)));
	padding-bottom: 0.625rem;
	font-family: myriad-pro, sans-serif;
	font-weight: 700;
	text-align: center;
	color: ${COLORS.grey};
	${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.white};
		`}
	&::selection {
		background-color: ${COLORS.somOrange};
		color: ${COLORS.white};
	}
`;
const Footer = styled.div`
	width: 100%;
	height: 3em;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	@media (max-width: ${SIZE.small}) {
		display: none;
	}
`;

const LinkList = styled.ul`
	height: 2em;
	display: flex;
	flex-direction: row;
`;

const Link = styled.li`
	padding-right: 2em;
	color: ${COLORS.lightGrey};
	&:hover {
		color: ${COLORS.somGreen};
	}
`;

const CopyMessage = styled.p`
	font-size: calc(15.6px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
	font-family: 'Montserrat', sans-serif;
	font-weight: 500;
	opacity: 0;
	text-align: center;
	color: ${COLORS.somGreen};
	animation: pop 3s 1;
	@keyframes pop {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;
